module.exports = require("@wallaby-ui/core");